import { API_CACHE_KEYS } from "api/cacheKeys";
import { ApiError, BaseQueryOptions, CachePolicy } from "api/types";
import { useCustomQuery } from "api/useCustomQuery";
import { JANZU_URL } from "config/config";
import { ActivityStatus } from "types/activity-status";

type UseGetActivityStatusParams = {
  options?: BaseQueryOptions<ActivityStatus>;
};

function useGetActivityStatus({ options }: UseGetActivityStatusParams = {}) {
  const url = `${JANZU_URL}device-api/activity-status`;
  return useCustomQuery<ActivityStatus>(API_CACHE_KEYS.activityStatus.get(), url, {
    cachePolicy: CachePolicy.NO_CACHE,
    ...options,
  });
}

type UseActivityStatusReturn = {
  // Get operations
  activityStatus: ActivityStatus | undefined;
  isLoadingActivityStatus: boolean;
  activityStatusError: ApiError | null;
  refetchActivityStatus: () => Promise<ActivityStatus>;
};

export function useActivityStatus(): UseActivityStatusReturn {
  const activityStatusQuery = useGetActivityStatus();

  return {
    // Get operations
    activityStatus: activityStatusQuery.data,
    isLoadingActivityStatus: activityStatusQuery.isFetching,
    activityStatusError: activityStatusQuery.error,
    refetchActivityStatus: activityStatusQuery.refetch,
  };
}
